"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalLoadingProvider = exports.useGlobalLoading = void 0;
var useGlobalLoading_hook_1 = require("./useGlobalLoading.hook");
Object.defineProperty(exports, "useGlobalLoading", { enumerable: true, get: function () { return useGlobalLoading_hook_1.useGlobalLoading; } });
Object.defineProperty(exports, "GlobalLoadingProvider", { enumerable: true, get: function () { return useGlobalLoading_hook_1.GlobalLoadingProvider; } });
//# sourceMappingURL=index.js.map